export default __webpack_public_path__ + "static/media/3.3b1817a5.jpg";